import { clsx } from 'clsx';

export function SearchInput({ placeholder = 'Search...', className, ...rest }) {
  return (
    <div className={clsx('relative', className)}>
      <svg
        className="absolute left-2.5 top-1/2 -translate-y-1/2 pointer-events-none"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#888"
        strokeWidth="2"
      >
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.6" y2="16.6" />
      </svg>
      <input
        className="w-full bg-surface-3 border border-transparent rounded pl-8 pr-3 py-1.5 text-[12px] text-text-dark placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-gat-green/30 focus:border-gat-green"
        placeholder={placeholder}
        {...rest}
      />
    </div>
  );
}
